<div
  class="origin"
  cdkOverlayOrigin
  #menuOrigin="cdkOverlayOrigin"
></div>

<ng-template
  cdkConnectedOverlay
  [cdkConnectedOverlayOrigin]="menuOrigin"
  [cdkConnectedOverlayOpen]="true"
  [cdkConnectedOverlayPush]="true"
  [cdkConnectedOverlayViewportMargin]="20"
  [cdkConnectedOverlayPositions]="overlayPositions"
>
  <div
    #menuOverlay
    class="menu"
    role="menu"
  >
    @if (menuTitle) {
      <div class="menu-item name">
        {{ menuTitle }}
      </div>
    }

    @for (option of options; track option.id) {
      <a
        [attr.data-id]="option.id"
        [routerLink]="option.href ?? null"
        [ngClass]="{
          'menu-item': true,
          'selected': option.selected,
        }"
        role="menuitem"
        (click)=onClick(option)
      >
        <!-- TEXT-ONLY option -->
        @if (option.name) {
          <div class="description">
            @if (option.icon?.type === IconType.FontAwesome) {
              <i
                [ngClass]="['fa-regular', 'fa-'+$safeNavigationMigration(option.icon?.id)]"
                [class.icon-on-right]="iconOnRight"
              ></i>
            }
            <span>
              {{ option.name }}
            </span>
          </div>
        }

        <!-- USER ID option -->
        @if (option.userId) {
          <div class="description">
            <motn-user-avatar
              size="small"
            ></motn-user-avatar>
          </div>
        }

        <!-- TEAM ID option -->
        @if (option.teamId) {
          <div class="description">
            <div
              [innerText]="getTeamName(option.teamId)"
            ></div>

            <!--  TODO: refactor to remove recursion -->
            <moti-team-users
              [teamId]="option.teamId"
              [whiteText]="true"
              [enableAdd]="false"
              [small]="true"
            ></moti-team-users>
          </div>
        }
      </a>
    }
  </div>
</ng-template>
